// Languages - Ranked by Total Speakers (native + second language)
export const LANGUAGES_CARDS = [
  { id: 1, name: "English", rank: 1, image: "/images/languages/english.png" },
  { id: 2, name: "Mandarin Chinese", rank: 2, image: "/images/languages/mandarin.png" },
  { id: 3, name: "Hindi", rank: 3, image: "/images/languages/hindi.png" },
  { id: 4, name: "Spanish", rank: 4, image: "/images/languages/spanish.png" },
  { id: 5, name: "French", rank: 5, image: "/images/languages/french.png" },
  { id: 6, name: "Arabic", rank: 6, image: "/images/languages/arabic.png" },
  { id: 7, name: "Bengali", rank: 7, image: "/images/languages/bengali.png" },
  { id: 8, name: "Portuguese", rank: 8, image: "/images/languages/portuguese.png" },
  { id: 9, name: "Russian", rank: 9, image: "/images/languages/russian.png" },
  { id: 10, name: "Japanese", rank: 10, image: "/images/languages/japanese.png" },
  { id: 11, name: "German", rank: 11, image: "/images/languages/german.png" },
  { id: 12, name: "Indonesian", rank: 12, image: "/images/languages/indonesian.png" },
  { id: 13, name: "Urdu", rank: 13, image: "/images/languages/urdu.png" },
  { id: 14, name: "Vietnamese", rank: 14, image: "/images/languages/vietnamese.png" },
  { id: 15, name: "Italian", rank: 15, image: "/images/languages/italian.png" },
  { id: 16, name: "Turkish", rank: 16, image: "/images/languages/turkish.png" },
  { id: 17, name: "Korean", rank: 17, image: "/images/languages/korean.png" },
  { id: 18, name: "Tamil", rank: 18, image: "/images/languages/tamil.png" },
  { id: 19, name: "Polish", rank: 19, image: "/images/languages/polish.png" },
  { id: 20, name: "Dutch", rank: 20, image: "/images/languages/dutch.png" },
  { id: 21, name: "Thai", rank: 21, image: "/images/languages/thai.png" },
  { id: 22, name: "Greek", rank: 22, image: "/images/languages/greek.png" },
  { id: 23, name: "Czech", rank: 23, image: "/images/languages/czech.png" },
  { id: 24, name: "Swedish", rank: 24, image: "/images/languages/swedish.png" },
  { id: 25, name: "Hebrew", rank: 25, image: "/images/languages/hebrew.png" },
  { id: 26, name: "Finnish", rank: 26, image: "/images/languages/finnish.png" },
  { id: 27, name: "Norwegian", rank: 27, image: "/images/languages/norwegian.png" },
  { id: 28, name: "Danish", rank: 28, image: "/images/languages/danish.png" },
  { id: 29, name: "Hungarian", rank: 29, image: "/images/languages/hungarian.png" },
  { id: 30, name: "Icelandic", rank: 30, image: "/images/languages/icelandic.png" }
];
